import { render, staticRenderFns } from "./WaiverDesign.vue?vue&type=template&id=702f7b84&scoped=true&"
import script from "./WaiverDesign.vue?vue&type=script&lang=js&"
export * from "./WaiverDesign.vue?vue&type=script&lang=js&"
import style0 from "./WaiverDesign.vue?vue&type=style&index=0&id=702f7b84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702f7b84",
  null
  
)

export default component.exports